var PATHNAME_REGEX = {
    OLDPDP: /^\/product-landing/i,
    PDP: /^\/pdp\/([^/]+)/i,
    BRANDCLUB: /^\/(brandclub)/i,
    BRAND: /^\/(brand)/i,
};
var PATHNAME_CHECKER = {
    isOldPDP: function (pathname) { return (pathname ? PATHNAME_REGEX.OLDPDP.exec(pathname) : false); },
    isPDP: function (pathname) { return (pathname ? PATHNAME_REGEX.PDP.exec(pathname) : false); },
    isBrandPage: function (pathname) { return (pathname ? PATHNAME_REGEX.BRAND.exec(pathname) : false); },
    isBrandclubPage: function (pathname) { return (pathname ? PATHNAME_REGEX.BRANDCLUB.exec(pathname) : false); },
};
var copyTrackingParamsToUrlSearchParams = function (trackingParams, urlSearchParams) {
    if (urlSearchParams === void 0) { urlSearchParams = new URLSearchParams(); }
    Object.entries(trackingParams).forEach(function (c) {
        var key = c[0];
        var val = c[1];
        if (key && val !== undefined) {
            urlSearchParams.set(key, val + '');
        }
    }, {});
    return urlSearchParams;
};

export { PATHNAME_CHECKER, PATHNAME_REGEX, copyTrackingParamsToUrlSearchParams };
//# sourceMappingURL=LocationTrackingUtils.js.map
